import { PrintedPageData, FormData } from './types';

export const markups: { [key: string]: number } = {
  '10000': 1000,
  '20000': 1100,
  '30000': 1200,
  '40000': 1300,
  '50000': 1350,
};

export const coef = 1.5;

export const fourPageEXW: { [key: string]: number } = {
  '10000': 300,
  '20000': 550,
  '30000': 750,
  '40000': 900,
  '50000': 1100,
};

export const fivePageEXW: { [key: string]: number } = {
  '10000': 375,
  '20000': 688,
  '30000': 937,
  '40000': 1126,
  '50000': 1375,
};

export const euro = 85;

export const INITIAL_QUANTITY = 10000;

export const MAX_QUANTITY = 59000;

export const QUANTITY_STEP = 1000;

export const MAX_COLOR_COUNT = 6;

export const minPages = 4;

export const maxPages = 5;

export const PRINTED_PAGE: PrintedPageData = {
  colorCount: 1,
  backSide: 0,
};

export const INITIAL_FORM_DATA: FormData = {
  quantity: INITIAL_QUANTITY,
  printedPagesData: Array(minPages).fill(PRINTED_PAGE),
  barcode: 0,
};
